export interface ICloseTripDto {
    datetime?: string;
    reason?: string;
    manual?: boolean;
}
